module.exports = __webpack_public_path__ + "static/media/blurred-image-yellow.86e16358.jpg";